// ── Pulsedge Color Palette ──────────────────────────────────
// Extracted from frontend-v1, aligned to product brief tiers

export const COLORS = {
  // Backgrounds
  bg: {
    primary: '#000000',
    secondary: '#0a0a0a',
    card: '#0d0d0d',
    cardHover: '#141414',
    elevated: '#1a1a2e',
    gradient: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
    glass: 'rgba(255, 255, 255, 0.04)',
    glassHover: 'rgba(255, 255, 255, 0.08)',
  },

  // Brand
  gold: {
    primary: '#ffd700',
    light: '#ffed4e',
    dark: '#ffb300',
    muted: 'rgba(255, 215, 0, 0.15)',
    border: 'rgba(255, 215, 0, 0.2)',
    glow: 'rgba(255, 215, 0, 0.4)',
  },

  // Semantic
  green: {
    primary: '#37ca37',
    neon: '#00ff88',
    muted: 'rgba(55, 202, 55, 0.15)',
    border: 'rgba(55, 202, 55, 0.3)',
  },

  red: {
    primary: '#ff4444',
    soft: '#ff6b6b',
    muted: 'rgba(255, 68, 68, 0.15)',
    border: 'rgba(255, 68, 68, 0.3)',
  },

  blue: {
    primary: '#00ccff',
    secondary: '#188bf6',
    muted: 'rgba(0, 204, 255, 0.15)',
    border: 'rgba(0, 204, 255, 0.3)',
  },

  purple: {
    primary: '#8b5cf6',
    muted: 'rgba(139, 92, 246, 0.15)',
    border: 'rgba(139, 92, 246, 0.3)',
  },

  // Text
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    muted: 'rgba(255, 255, 255, 0.4)',
    disabled: 'rgba(255, 255, 255, 0.2)',
  },

  // Borders
  border: {
    subtle: 'rgba(255, 255, 255, 0.06)',
    light: 'rgba(255, 255, 255, 0.1)',
    medium: 'rgba(255, 255, 255, 0.15)',
  },
};

// ── Tier Colors ────────────────────────────────────────────
export const TIER_COLORS = {
  free: {
    primary: COLORS.text.secondary,
    bg: COLORS.bg.glass,
    border: COLORS.border.light,
    badge: '#666',
  },
  pro: {
    primary: COLORS.blue.primary,
    bg: COLORS.blue.muted,
    border: COLORS.blue.border,
    badge: COLORS.blue.primary,
  },
  elite: {
    primary: COLORS.gold.primary,
    bg: COLORS.gold.muted,
    border: COLORS.gold.border,
    badge: COLORS.gold.primary,
    glow: `0 0 20px ${COLORS.gold.glow}`,
  },
};
